import { Expose, Type } from '@nts/std/serialization';
import { GridFieldMetaData } from './grid-field-meta-data';
import { ExternalGridFieldMetaData } from './external-grid-field-meta-data';
import type { ExternalGridFieldMetaDataInterface, GridColumnsMetaDataInterface, GridFieldInterface, GridFieldMetaDataInterface } from '@nts/std/interfaces';

export class GridColumnsMetaData implements GridColumnsMetaDataInterface {

    constructor() {
        this.gridFields = [];
        this.externals = [];
    }

    @Expose()
    modelName: string;

    @Expose()
    @Type(() => GridFieldMetaData)
    gridFields: GridFieldMetaDataInterface[];

    @Expose()
    @Type(() => ExternalGridFieldMetaData)
    externals: ExternalGridFieldMetaDataInterface[];

    @Expose()
    get sortedFields(): GridFieldInterface[] {
        return [...this.gridFields, ...this.externals].sort((a, b) => a.position - b.position);
    }

}
